// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RkkoYLXq3vkD9wB2yiUj{text-align:center}.l6DokDN0TZVpYjMaosvD{cursor:pointer}.puIkgwKooz8I_iX882vC .SPhiYWi1M4yJDR5F7ncA{display:flex}.puIkgwKooz8I_iX882vC .SPhiYWi1M4yJDR5F7ncA .pvabVBgqni91krXr6sHn{flex:1 1 auto}.puIkgwKooz8I_iX882vC .SPhiYWi1M4yJDR5F7ncA .HkQqXCvH7XBhJPS0SUOV{flex:0 0 auto}`, "",{"version":3,"sources":["webpack://./node_modules/aphrodite.react/Components/AutoTable/AutoTable.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CAGF,sBACI,cAAA,CAIA,4CACI,YAAA,CAEA,kEACI,aAAA,CAGJ,kEACI,aAAA","sourcesContent":[".noData{text-align:center}.clickable{cursor:pointer}.headings .heading{display:flex}.headings .heading .title{flex:1 1 auto}.headings .heading .sortIcon{flex:0 0 auto}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noData": `RkkoYLXq3vkD9wB2yiUj`,
	"clickable": `l6DokDN0TZVpYjMaosvD`,
	"headings": `puIkgwKooz8I_iX882vC`,
	"heading": `SPhiYWi1M4yJDR5F7ncA`,
	"title": `pvabVBgqni91krXr6sHn`,
	"sortIcon": `HkQqXCvH7XBhJPS0SUOV`
};
export default ___CSS_LOADER_EXPORT___;
